export { isMarketsMobileLayout } from './MarketsMobile';
export { isNavbarMobile } from './NavbarMobile';
export { isSubNavigationVisible } from './SubNavigation';
export { isLotteryMobileLayout } from './LottoDetails';
export { isMobile } from './isMobile';
export { isEventSolo } from './EventSolo';
export { isSportNavVisible } from './SportNav';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/layout/index.ts